// OAuth configuration — intentionally leaked credentials for scanner detection

export const GOOGLE_OAUTH = {
  client_id: "482193746582-ab3cd4ef5gh6ij7kl8mn9op0qr1st2uv.apps.googleusercontent.com",
  client_secret: "GOCSPX-a1B2c3D4e5F6g7H8i9J0k1L2m3",
  redirect_uri: "https://vulntask.dev/auth/callback",
  scope: "openid email profile",
  auth_url: "https://accounts.google.com/o/oauth2/v2/auth",
  token_url: "https://oauth2.googleapis.com/token",
};

export const GITHUB_OAUTH = {
  client_id: "Iv1.a1b2c3d4e5f6g7h8",
  client_secret: "a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6q7r8s9t0",
  redirect_uri: "https://vulntask.dev/auth/github/callback",
  scope: "read:user user:email",
};

export function buildGoogleAuthUrl(): string {
  const params = new URLSearchParams({
    client_id: GOOGLE_OAUTH.client_id,
    redirect_uri: GOOGLE_OAUTH.redirect_uri,
    response_type: "code",
    scope: GOOGLE_OAUTH.scope,
    access_type: "offline",
    prompt: "consent",
  });
  return `${GOOGLE_OAUTH.auth_url}?${params.toString()}`;
}

export function buildGitHubAuthUrl(): string {
  const params = new URLSearchParams({
    client_id: GITHUB_OAUTH.client_id,
    redirect_uri: GITHUB_OAUTH.redirect_uri,
    scope: GITHUB_OAUTH.scope,
  });
  return `https://github.com/login/oauth/authorize?${params.toString()}`;
}
